import { render } from "./IconArrow.vue?vue&type=template&id=025d5a57"
const script = {}
script.render = render

export default script